import { render, staticRenderFns } from "./DeptGroupList.vue?vue&type=template&id=20812b59"
import script from "./DeptGroupList.vue?vue&type=script&lang=js"
export * from "./DeptGroupList.vue?vue&type=script&lang=js"
import style0 from "./DeptGroupList.vue?vue&type=style&index=0&id=20812b59&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports